/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/leaf_medium'
export default icon
